import { DesignProp, GeneralProp } from "../PropCategories";

export const textAlign = {
  name: "Text Align",
  nameI18n: "builder_ui.prop_type.styles.text_align",
  category: [DesignProp, GeneralProp],
  type: "alignment",
  defaultValue: "left",
  alignment_options: [
    {
      type: "left",
      icon: "20-builder-ui-style-text-align-left",
    },
    {
      type: "center",
      icon: "20-builder-ui-style-text-align-center",
    },
    {
      type: "right",
      icon: "20-builder-ui-style-text-align-right",
    },
    {
      type: "justify",
      icon: "20-builder-ui-style-text-align-justify",
    },
  ],
} as const;
